export default "__VITE_ASSET__Dqh81kD___"